import { Component, Input} from '@angular/core';
import { NbDialogRef, NbThemeService } from '@nebular/theme';
import { ApiService } from './../../../../shared/api.service';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { config } from './../../../../../../config';
import {ConfirmationService} from 'primeng/api';
@Component({
selector: 'nb-dialog',
template: `
<nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="xlarge">
  <nb-card-header>Add Reason</nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-xl-12" style='center;'>
        <b>Input the name of college where you are seeking admission :</b>
        <input type="text" class="form-control" (input)="onSearchChange($event.target.value)" [(ngModel)]="reason" name='inputTranscriptName' id="inputTranscriptName" placeholder="Reason">
      </div><br><br><br>
      <div class="col-xl-12" *ngIf="showUpload == true">
        <p-fileUpload ngDefaultControl [accept]="'.jpg,.jpeg,.png,.pdf,.PNG,.JPEG,.JPG,.PDF'" mode="basic" auto="true"
          chooseLabel="Upload" name="file" url="{{transUploadUrl}}?user_id={{user_id}}&&transcript_name=Transfer Certificate&&hiddentype=User_Marsheet&&reason={{reason}}"
          maxFileSize="5000000"
          (onBeforeSend)="onBeforeSend($event)"
          (onUpload)="onUpload($event)"
          (onSelect)="onSelect($event)"
          (onError)="onErrorFileUpload($event)">
        </p-fileUpload>
        <span *ngIf='uploaderror == true' style="color:red; font-size: x-large;">Max uploaded file size should be 5 MB.</span>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton hero status="primary" (click)="dismiss()">Close</button>
  </nb-card-footer>
</nb-card>
`,
providers:[ConfirmationService],
})
export class TranscriptDialogComponent {
@Input() title: string;
@Input() user_id: any;
cbse_marks;
currenttoken;
showUpload;
loading = false;
user = { name : "", id:""};
reason;
serverUrl = config.serverUrl;
uploaderror = false;
uploaderror1 = false;
transUploadUrl = config.docUploadUrl;

constructor(
  protected ref: NbDialogRef<TranscriptDialogComponent>,
  protected api : ApiService,
  private authService: NbAuthService,
  public themeService : NbThemeService,
  private confirmationService: ConfirmationService,
  ) 
  {
    
  }

  dismiss() {
  this.ref.close();
  }

  onBeforeSend(event) {
    this.loading = true;
    this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
       this.currenttoken = token;
        event.xhr.setRequestHeader("Authorization", `Bearer ` +this.currenttoken);
        event.formData.append('token',''+this.currenttoken);
        }
    });
  }
  
  onUpload(event) {
      const reader = new FileReader();
      if(event.files && event.files.length) {
        const [file] = event.files;
        reader.readAsDataURL(file);
        this.loading = false;
        this.ref.close(file);
      }
  
  }
  
  selectedFile: File;

  onSelect($event: any): void {
		var maxFileSize =  5000000;
		var imgArr = $event.files[0].name.split('.');
    var extension = imgArr[imgArr.length - 1].trim();
    
    if(extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='pdf'){
			this.uploaderror1 = true;
    }
    
    if ($event.files[0].size > maxFileSize) {
      this.uploaderror = true;
      this.confirmationService.confirm({
				message: 'Maximum file size should be 5 MB.',
				header: 'Invalid File Size',
				icon: 'pi pi-info-circle',
				rejectVisible : false,
				acceptLabel: 'Ok'
			});
    }

    
  }


  ngOnInit() {
     this.api.getTheme().subscribe((data: any) => {
        if(data['data']){
          this.themeService.changeTheme(data['data']);
        }else{
          this.themeService.changeTheme('default');
        }
      });
   }

   onSearchChange(searchValue : string ) {
    if(searchValue.length > 3){
      this.showUpload = true;
    }else{
      this.showUpload = false;
    }
    
  }
  
}
